var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _vm.isImplementedTemplateName
        ? _c(
            "v-card-title",
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("info")]),
              _vm._v(" Form Information\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.value == _vm.externalLink
        ? _c("v-flex", { attrs: { "pa-2": "" } }, [
            _c("p", [
              _vm._v(
                "\n      External link icons can be specified in the icon field. The full list of available icons "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://material.io/resources/icons/?style=baseline",
                    target: "_blank",
                  },
                },
                [_vm._v("can be found here")]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isImplementedTemplateName ? _c("v-divider") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }